import MainScene from './main/main.scene';
import GameManager from './game-manager';
import { TransitionScene } from '../lib/transitions';

const scenes = [GameManager, MainScene, TransitionScene];

export default scenes;
